import { mmComponent } from "@/types";

abstract class Component<TOptions> implements mmComponent<TOptions> {
  protected _options: TOptions;
  protected _element: HTMLElement;

  constructor(element: HTMLElement, options?: TOptions) {
    this._element = element;
    this._options = { ...this.getDefaults(), ...options };
  }

  public abstract getDefaults(): TOptions;

  public get options(): TOptions {
    return this._options;
  }
}

export default Component;
